import {FixRoleWarningModalProps} from "./types";
import Alert from "@ui-components/Alert";
import {useIntl} from "react-intl";
import Button from "@ui-components/Button";
import Modal from "@ui-components/Modal";
export const FixRoleWarningModal = ({
  onConfirm,
  onCancel,
}:FixRoleWarningModalProps) => {
  const intl = useIntl();
  return <Modal
    onExit={onCancel}
  >
    <div className={"my-6 flex flex-col gap-y-5 "}>
    <Alert
      type={"warning"}
      text={
        intl.formatMessage({
          id: "warning_fix_role",
          defaultMessage: "Sei stato disassociato dall'organizzazione di cui facevi parte, Imposta il tuo ruolo per continuare",
        })}
    />
    <div className={"flex justify-center items-center"}>
      <Button
        onClick={onConfirm}
        className={"mr-2"}
      >
        {intl.formatMessage({
          id: "fix_role",
          defaultMessage: "Imposta il ruolo",
        })}
      </Button>
    </div>
    </div>
  </Modal>
}